import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DashboardInfoNetzbetreiberRto } from './dashboard-info-netzbetreiber-rto';
import { DashboardInfoWestnetzRto } from './dashboard-info-westnetz-rto';
import { DashboardInfoContainer } from '../../domain/model/dashboard-info-container';
import { TeilgebietSelectionService } from '../common/teilgebiet/teilgebiet-selection.service';
import { map } from 'rxjs/operators';
import { NetzzuordnungSnapshot } from '../../domain/model/netzzuordnung-snapshot';

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    private http = inject(HttpClient);
    private teilgebieteService = inject(TeilgebietSelectionService);

    public getDashboardInfo(isAdmin: boolean): Observable<DashboardInfoContainer> {
        if (isAdmin) {
            return this.getDashboardInfoSnapshotWestnetzRTO().pipe(map(rto => {
                let dashboardInfoDTO = new DashboardInfoContainer();
                dashboardInfoDTO.aktiveDatenAbfrage = rto.aktiveDatenAbfrage;
                dashboardInfoDTO.aufteilungsschluesselCount = rto.aufteilungsschluesselCount;
                dashboardInfoDTO.erzeugungsAnlagenCount = rto.erzeugungsAnlagenCount;
                dashboardInfoDTO.netzzuordnungCount = rto.netzzuordnungCount;
                dashboardInfoDTO.aktiveDatenAbfrage = rto.aktiveDatenAbfrage;
                dashboardInfoDTO.toOldNetzbetreibersCsv = rto.toOldNetzbetreibersCsv;
                dashboardInfoDTO.isUserAssignedToAktiveDatenabfrage = false; // admin/wn user are never participant
                dashboardInfoDTO.isErzeugungsAnlagenPflegeAktiv = rto.isErzeugungsAnlagenPflegeAktiv;
                dashboardInfoDTO.netzzuordnungImport = rto.netzzuordnungImport;
                return dashboardInfoDTO;
            }));
        } else {
            return this.getDashboardInfoSnapshotNetzbetreiberRTO(this.teilgebieteService.getSelectedStadtwerkeId()).pipe(map(rto => {
                let dashboardInfoDTO = new DashboardInfoContainer();
                dashboardInfoDTO.aktiveDatenAbfrage = rto.aktiveDatenAbfrage;
                dashboardInfoDTO.aufteilungsSchluesselSubmitted = rto.aufteilungsSchluesselSubmitted;
                dashboardInfoDTO.erzeugungsAnlagenCount = rto.erzeugungsAnlagenCount;
                dashboardInfoDTO.lastConfirmedUuidDate = rto.lastConfirmedUuidDate;
                dashboardInfoDTO.erzeugungsAnlageLastUpdateDate = rto.erzeugungsAnlageLastUpdateDate;
                dashboardInfoDTO.numberOfDeleteNetzzuordnung = rto.numberOfDeleteNetzzuordnung;
                dashboardInfoDTO.netzbetreiberLastUpdate = rto.netzbetreiberLastUpdate;
                dashboardInfoDTO.isErzeugungsanlageLastChangedAndNetzbeteiberLastUpdateToOld =
                    rto.isErzeugungsanlageLastChangedAndNetzbeteiberLastUpdateToOld;
                dashboardInfoDTO.netzzuordnungCount = rto.netzzuordnungCount;
                dashboardInfoDTO.numberOfUncofirmedNetzzuordnungUUIDs = rto.numberOfUncofirmedNetzzuordnungUUIDs;
                dashboardInfoDTO.isUserAssignedToAktiveDatenabfrage = rto.isUserAssignedToAktiveDatenabfrage;
                dashboardInfoDTO.isErzeugungsAnlagenPflegeAktiv = rto.isErzeugungsAnlagenPflegeAktiv;
                return dashboardInfoDTO;
            }));
        }
    }

    private getSnapshot<T>(typeUrl: string, stadtwerkeId: string): Observable<T> {
        let params = new HttpParams();
        params = params.set('stadtwerkeId', stadtwerkeId);
        return this.http.get<T>(environment.API_URL + '/' + typeUrl + '/snapshot', { params });
    }

    public getNetzzuordnungSnapshot$(stadtwerkeId?: string): Observable<NetzzuordnungSnapshot> {
        return this.getSnapshot<NetzzuordnungSnapshot>('netzzuordnung', stadtwerkeId);
    }

    private getDashboardInfoSnapshotNetzbetreiberRTO(stadtwerkeId: string):
        Observable<DashboardInfoNetzbetreiberRto> {
        return this.http.get<DashboardInfoNetzbetreiberRto>(environment.API_URL + '/dashboard/' + stadtwerkeId);
    }

    public getDashboardInfoSnapshotWestnetzRTO(): Observable<DashboardInfoWestnetzRto> {
        return this.http.get<DashboardInfoWestnetzRto>(environment.API_URL + '/dashboard' + '/westnetz');
    }
}
